import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class TitleCta {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    const targets = [
      this.el.querySelector('.title-cta--title'),
      this.el.querySelector('.title-cta--actions'),
    ].filter(Boolean)

    if (!targets.length) return

    gsap.set(targets, { y: 30, opacity: 0 })

    gsap.to(targets, {
      y: 0,
      opacity: 1,
      duration: 0.9,
      stagger: 0.12,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: this.el,
        start: 'top 85%',
        toggleActions: 'play none none none',
      },
    })
  }
}
